import React from "react";
import Modal from "material-ui/Modal";
import Paper from "material-ui/Paper";
import Button from "material-ui/Button";
import Icon from "material-ui/Icon";
import Typography from "material-ui/Typography";
import Select from "material-ui/Select";
import Input, { InputLabel } from "material-ui/Input";
import { MenuItem } from "material-ui/Menu";
import Checkbox from "material-ui/Checkbox";
import TextField from "material-ui/TextField";
import Tabs, { Tab } from "material-ui/Tabs";
import Switch from "material-ui/Switch";
import Grid from "material-ui/Grid";
import Chip from "material-ui/Chip";
import Radio, { RadioGroup } from "material-ui/Radio";
import List, { ListItem, ListItemText } from "material-ui/List";
import Divider from "material-ui/Divider";
import { toast } from "react-toastify";
import {
  getSubTestTr,
  updateSubTestTr,
  getCustomerTargets6,
  getSubTestPing,
  getCustomerTargets4,
  updateSubTestPing,
  getUpTime,
  getNetScan,
  getCustomerPoELoad,
  getWireMap,
  getFiberLengthLoss,
  getCableList,
  getMaxThroughPut,
  getSubtestSettings
} from "../../../redux/actions";

import {
  FormControl,
  FormHelperText,
  FormControlLabel,
  FormLabel,
  FormGroup
} from "material-ui/Form";
import { withStyles } from "material-ui/styles";
import styles from "./styles";
import { connect } from "react-redux";

import { ModalHeader, ModalContents, ModalFooter } from "../../common/modal";

import { validateFormData } from "../../../common/formtool";

import generateNames from "../../../common/namegenerate";

import { CUSTOM_METADATA_STANDARD } from "../../../common/constants";

import {
  nwTestData,
  transTestData,
  wireTestData,
  poeTestData,
  fiberTestData
} from "../../subtestsettings/subtestenum";
import PINGEdit from "./common/pingedit";
import TREdit from "./common/tredit";
import NetScanEdit from "./common/netscanedit";
import PoELoadEdit from "./common/poeloadedit";
import UpTimeEdit from "./common/uptimeedit";
import WireMapEdit from "./common/wiremapedit";
import MaxthroughputEdit from "./common/maxthroughputedit";
import CustomDataEdit from "./common/customdataedit";
import CableDataEdit from "./common/cabledataedit";
import WebDataEdit from "./common/webdataedit";
import VoipDataEdit from "./common/voipdataedit";
import VideoDataEdit from "./common/videodataedit";
import CCTVDataEdit from "./common/cctvdataedit";
import FiberLengthLossEdit from "./common/fiberlengthlossedit";
import Tooltip from "material-ui/Tooltip"; 

const HtmlTooltip = withStyles(theme => ({
  tooltip: {
    backgroundColor: "#5a5a5a",
    color: "white",
    maxWidth: "auto",
    fontSize: theme.typography.pxToRem(15),
    border: "1px solid #dadde9"
  }
}))(Tooltip);

class NewSignalTekTest extends React.Component {
  constructor(props) {
    super(props);
    const { job, type, userPreference, lengthMeasurementUnit } = props;
    this.state = {
      open: true,
      errors: {},
      tabs:
        type == "fiber"
          ? job.metadatalookupid === CUSTOM_METADATA_STANDARD || (userPreference && userPreference.FromTreeview)
            ? [
                "tab_details",
                "tab_identifiers",
                "tab_network",
                "tab_transmission",
                "tab_fiber"
              ]
            : ["tab_details", "tab_network", "tab_transmission", "tab_fiber"]
          : job.metadatalookupid === CUSTOM_METADATA_STANDARD || (userPreference && userPreference.FromTreeview)
          ? [
              "tab_details",
              "tab_identifiers",
              "tab_network",
              "tab_transmission",
              "tab_wiremap",
              "tab_poe"
            ]
          : [
              "tab_details",
              "tab_network",
              "tab_transmission",
              "tab_wiremap",
              "tab_poe"
            ],

      // tabs:
      //   type == "fiber"
      //     ? [
      //         props.translate("add_cust_tab_details"),
      //         props.translate("add_cust_tab_network"),
      //         props.translate("add_cust_tab_transmission")
      //       ]
      //     : [
      //         props.translate("add_cust_tab_details"),
      //         props.translate("add_cust_tab_network"),
      //         props.translate("add_cust_tab_transmission"),
      //         props.translate("add_cust_tab_wiremap"),
      //         props.translate("add_cust_tab_poe")
      //       ],
      tabPosition: 0,
      testPrefixType: "custom",
      test: {
        jobid: job.id,
        prefix: "",
        startvalue: "01",
        endvalue: "24",
        names: null,
        floor: "",
        telecommunicationspace: "",
        panel: "",
        cablestandard: "",
        cablestandardname: "",
        linkmodel: "",
        linkmodelname: "",
        cabletype: "",
        cabletypename: "",
        cablebrand: "",
        cablebrandname: "",
        cablemodelid: "",
        cablemodelname: "",
        connectorbrandnear: "",
        connectorbrandnearname: "",
        connectorbrandfar: "",
        connectorbrandfarname: "",
        nvp: 68,
        cableshielding: "U/UTP",
        metadata: [
          {
            level: "1",
            value: "",
            field: job.level1,
            default: job.level1 !== "",
            enabled: job.level1 !== ""
          },
          {
            level: "2",
            value: "",
            field: job.level2,
            default: job.level2 !== "",
            enabled: job.level2 !== ""
          },
          {
            level: "3",
            value: "",
            field: job.level3,
            default: job.level3 !== "",
            enabled: job.level3 !== ""
          },
          {
            level: "4",
            value: "",
            field: job.level4,
            default: job.level4 !== "",
            enabled: job.level4 !== ""
          },
          {
            level: "5",
            value: "",
            field: job.level5,
            default: job.level5 !== "",
            enabled: job.level5 !== ""
          },
          {
            level: "6",
            value: "",
            field: job.level6,
            default: job.level6 !== "",
            enabled: job.level6 !== ""
          }
        ],
        ping4:
          userPreference && userPreference.ping4 ? userPreference.ping4 : false,
        ping6:
          userPreference && userPreference.ping6 ? userPreference.ping6 : false,
        traceroute4:
          userPreference && userPreference.traceroute4
            ? userPreference.traceroute4
            : false,
        traceroute6:
          userPreference && userPreference.traceroute6
            ? userPreference.traceroute6
            : false,
        netscan:
          userPreference && userPreference.netscan
            ? userPreference.netscan
            : false,
        maxthroughput:
          userPreference && userPreference.maxthroughput
            ? userPreference.maxthroughput
            : false,
        uptime:
          userPreference && userPreference.uptime
            ? userPreference.uptime
            : false,
        customdata:
          userPreference && userPreference.customdata
            ? userPreference.customdata
            : false,
        cabledata:
          userPreference && userPreference.cabledata
            ? userPreference.cabledata
            : false,
        webdata:
          userPreference && userPreference.webdata
            ? userPreference.webdata
            : false,
        voipdata:
          userPreference && userPreference.voipdata
            ? userPreference.voipdata
            : false,
        videodata:
          userPreference && userPreference.videodata
            ? userPreference.videodata
            : false,
        cctvdata:
          userPreference && userPreference.cctvdata
            ? userPreference.cctvdata
            : false,
        wiremap:
          userPreference && userPreference.wiremap
            ? userPreference.wiremap
            : false,
        poeload:
          userPreference && userPreference.poeload
            ? userPreference.poeload
            : false,
        fiberlengthloss:
        userPreference && userPreference.fiberlengthloss
        ? userPreference.fiberlengthloss
        : false
      },
      cablemodels: [],
      linkmodels: [],
      cabletypes: [],
      isNonGenericCableBrand: false,
      disabledToogleIdentifier: false,
      testCount: 0,
      isSubTestError: false,
      tabView: "tab_details",
      customerTargets4: null,
      customerTargets6: null,
      selectedTestResult: null,
      ping4Edit: false,
      ping6Edit: false,
      selectedTrResult: null,
      netScan: null,
      customerPoELoad: null,
      editModalOpen: false,
      upTime: null,
      wireMap: null,
      cableList: {},
      maxThroughPut: null,
      fiberLengthLoss: null,
      subtestSettings: null,
      testIDType: "sequential",
      lantekfiles: null,
      modalRef: React.createRef()
      //showRestore: false,
      //isDetailsUpdated: false
    };
    this.onChangeMetadataField = this.onChangeMetadataField.bind(this);
    this.checkForAlreadySelectedSubtests = this.checkForAlreadySelectedSubtests.bind(
      this
    );
    this.checkForAlreadySelectedSubtestsSignaltek = this.checkForAlreadySelectedSubtestsSignaltek.bind(
      this
    );
    this.handleImport = this.handleImport.bind(this);
    this.handleUpload = this.handleUpload.bind(this);
  }

  componentWillUnmount() {
    const { sessionStorage } = window;
    sessionStorage.removeItem("TR4DEFAULT");
    sessionStorage.removeItem("TR6DEFAULT");
    sessionStorage.removeItem("PING4DEFAULT");
    sessionStorage.removeItem("PING6DEFAULT");
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      selectedTrResult,
      customerTargets6,
      customerTargets4,
      upTime,
      netScan,
      selectedTestResult,
      customerPoELoad,
      wireMap,
      cableList,
      maxThroughPut,
      fiberLengthLoss,
      subtestSettings
    } = prevProps;
    if (selectedTrResult && this.props.selectedTrResult != selectedTrResult) {
      this.setState({ selectedTrResult });
    }
    if (customerTargets6 && this.props.customerTargets6 != customerTargets6) {
      this.setState({ customerTargets6 });
    }
    if (customerTargets4 && this.props.customerTargets4 != customerTargets4) {
      this.setState({ customerTargets4 });
    }
    if (upTime && this.props.upTime !== upTime) {
      this.setState({ upTime });
    }
    if (netScan && this.props.netScan !== netScan) {
      this.setState({ netScan });
    }
    if (
      selectedTestResult &&
      this.props.selectedTestResult != selectedTestResult
    ) {
      this.setState({ selectedTestResult });
    }
    if (customerPoELoad && this.props.customerPoELoad !== customerPoELoad) {
      this.setState({ customerPoELoad });
    }
    if (wireMap && this.props.wireMap !== wireMap) {
      this.setState({ wireMap });
    }
    if (cableList && this.props.cableList !== cableList) {
      this.setState({ cableList });
    }
    if (maxThroughPut && this.props.maxThroughPut !== maxThroughPut) {
      this.setState({ maxThroughPut });
    }
    if (subtestSettings && this.props.subtestSettings !== subtestSettings) {
      this.setState({ subtestSettings });
    }
    if (fiberLengthLoss && this.props.fiberLengthLoss !== fiberLengthLoss) {
      this.setState({ fiberLengthLoss });
    }
  }

  componentWillReceiveProps(nextProps) {
    const {
      selectedTrResult,
      customerTargets4,
      customerTargets6,
      selectedTestResult,
      upTime,
      netScan,
      customerPoELoad,
      wireMap,
      cableList,
      maxThroughPut,
      fiberLengthLoss,
      subtestSettings
    } = nextProps;

    this.setState({
      //subTestPingUpdated,
    });

    if (selectedTrResult && this.props.selectedTrResult != selectedTrResult) {
      this.setState({ selectedTrResult });
    }
    if (customerTargets4 && this.props.customerTargets4 != customerTargets4) {
      this.setState({ customerTargets4 });
    }
    if (customerTargets6 && this.props.customerTargets6 != customerTargets6) {
      this.setState({ customerTargets6 });
    }
    if (
      selectedTestResult &&
      this.props.selectedTestResult != selectedTestResult
    ) {
      this.setState({ selectedTestResult });
    }
    if (upTime && this.props.upTime != upTime) {
      this.setState({ upTime });
    }
    if (netScan && this.props.netScan != netScan) {
      this.setState({ netScan });
    }
    if (customerPoELoad && this.props.customerPoELoad !== customerPoELoad) {
      this.setState({ customerPoELoad });
    }
    if (wireMap && this.props.wireMap !== wireMap) {
      this.setState({ wireMap });
    }
    if (cableList && this.props.cableList !== cableList) {
      this.setState({ cableList });
    }
    if (maxThroughPut && this.props.maxThroughPut !== maxThroughPut) {
      this.setState({ maxThroughPut });
    }
    if (subtestSettings && this.props.subtestSettings !== subtestSettings) {
      this.setState({ subtestSettings });
    }
    if (fiberLengthLoss && this.props.fiberLengthLoss !== fiberLengthLoss) {
      this.setState({ fiberLengthLoss });
    }
  }

  checkForAlreadySelectedSubtests = (test, isCopper) => {
    let { testCount } = this.state;
    let { job, userPreference } = this.props;
    if (
      (job.metadatalookupid === CUSTOM_METADATA_STANDARD || userPreference.FromTreeview) &&
      userPreference.metadata
    ) {
      let metadata = [...userPreference.metadata];
      let curStateMetaData = [...test.metadata];
      metadata.forEach(e => {
        curStateMetaData.forEach(ce => {
          if (ce.level === e.level) {
            ce.field = e.field;
            ce.value = e.value;
            e.value ? (ce.enabled = true) : (ce.enabled = false);
          }
        });
      });
      test.metadata = curStateMetaData;
      test.allmetadataoptions = true;
      this.setState({
        test: {
          ...test
        }
      });
    }
  };
  checkForAlreadySelectedSubtestsSignaltek = (test, isCopper) => {
    let { testCount } = this.state;
    let { job, userPreference } = this.props;
    nwTestData.map((item, index) => {
      if (test[item.id]) {
        testCount++;
      }
    });

    transTestData.map((item, index) => {
      if (test[item.id]) {
        testCount++;
      }
    });
    if (this.props.type == "copper") {
      wireTestData.map((item, index) => {
        if (test[item.id]) {
          testCount++;
        }
      });

      poeTestData.map((item, index) => {
        if (test[item.id]) {
          testCount++;
        }
      });
    }
    else {
      fiberTestData.map((item, index) => {
        if (test[item.id]) {
          testCount++;
        }
      });
    }

    this.setState({
      testCount,
      isSubTestError: false
    });
  };

  handleTabChange = (event, value) => {
    let { tabPosition, tabs } = this.state;
    let prevTabClicked = tabPosition > value;
    let allowTabChange = prevTabClicked ? true : this.validate();
    if (allowTabChange) {
      this.setState({ tabPosition: value, tabView: tabs[value] });
    }
  };

  tabNext() {
    const { tabs, tabPosition } = this.state;
    const { userPreference } = this.props;
    let pos = tabPosition + 1;
    let check = this.canTabNext();
    if (this.props.job.metadatalookupid === CUSTOM_METADATA_STANDARD || (userPreference && userPreference.FromTreeview)) {
      if (tabPosition > 1) {
        if (check.can)
          this.setState({
            tabPosition: check.pos,
            tabView: tabs[check.pos]
          });
      } else {
        let validate = this.validate();
        if (validate && check.can)
          this.setState({ tabPosition: check.pos, tabView: tabs[check.pos] });
      }
    } else {
      if (tabPosition > 0) {
        if (check.can)
          this.setState({
            tabPosition: check.pos,
            tabView: tabs[check.pos]
          });
      } else {
        let validate = this.validate();
        if (validate && check.can)
          this.setState({ tabPosition: check.pos, tabView: tabs[check.pos] });
      }
    }
    this.state.modalRef.current.scrollTo({top: 0});
  }

  tabBack() {
    const { tabs, tabPosition } = this.state;
    let check = this.canTabBack();
    if (check.can)
      this.setState({ tabPosition: check.pos, tabView: tabs[check.pos] });
    this.state.modalRef.current.scrollTo({top: 0});
  }

  canTabNext() {
    const { tabs, tabPosition } = this.state;
    let pos = tabPosition + 1;

    return pos < tabs.filter(n => n).length
      ? { can: true, pos: pos }
      : { can: false, pos: pos };
  }

  canTabBack() {
    const { tabPosition } = this.state;
    let pos = tabPosition - 1;
    return pos >= 0 ? { can: true, pos: pos } : { can: false, pos: pos };
  }

  tabsComplete() {
    const { tabs, tabPosition } = this.state;
    return tabPosition === tabs.filter(n => n).length - 1 ? true : false;
  }

  handleClose = () => {
    //this.setState({ tabPosition: 0, tabView: this.state.tabs[0] });

    this.props.handleClose();
    this.props.cancel("cancel");
  };

  compare = (a, b) => {
    if (a.name < b.name) {
      return -1;
    } else if (a.name > b.name) {
      return 1;
    }
    return 0;
  };
  onSubtestChange = e => {
    let test = { ...this.state.test };
    let { testCount } = this.state;
    //e.target.checked == true ? testCount++ : testCount--;
    if (e.target.name == "nw-all") {
      test[e.target.name] = e.target.checked;
      nwTestData.map((item, index) => {
        e.target.checked == true ? testCount++ : testCount--;
        return (test[item.id] = e.target.checked);
      });
    } else if (e.target.name == "tr-all") {
      test[e.target.name] = e.target.checked;
      transTestData.map((item, index) => {
        e.target.checked == true ? testCount++ : testCount--;
        return (test[item.id] = e.target.checked);
      });
    } else if (e.target.name == "wm-all") {
      test[e.target.name] = e.target.checked;
      wireTestData.map((item, index) => {
        e.target.checked == true ? testCount++ : testCount--;
        return (test[item.id] = e.target.checked);
      });
    } else if (e.target.name == "po-all") {
      test[e.target.name] = e.target.checked;
      poeTestData.map((item, index) => {
        e.target.checked == true ? testCount++ : testCount--;
        return (test[item.id] = e.target.checked);
      });
    } else if (e.target.name == "fb-all") {
      test[e.target.name] = e.target.checked;
      fiberTestData.map((item, index) => {
        e.target.checked == true ? testCount++ : testCount--;
        return (test[item.id] = e.target.checked);
      });
    } else {
      e.target.checked == true ? testCount++ : testCount--;
      test[e.target.name] = e.target.checked;

      if (nwTestData.find(o => o.id === e.target.name)) {
        if (
          nwTestData.filter(o => test[o.id] && test[o.id] == true).length ==
          nwTestData.length
        ) {
          test["nw-all"] = true;
        } else {
          test["nw-all"] = false;
        }
      }
      if (transTestData.find(o => o.id === e.target.name)) {
        if (
          transTestData.filter(o => test[o.id] && test[o.id] == true).length ==
          transTestData.length
        ) {
          test["tr-all"] = true;
        } else {
          test["tr-all"] = false;
        }
      }
      if (wireTestData.find(o => o.id === e.target.name)) {
        if (
          wireTestData.filter(o => test[o.id] && test[o.id] == true).length ==
          wireTestData.length - 1
        ) {
          test["wm-all"] = true;
        } else {
          test["wm-all"] = false;
        }
      }
      if (poeTestData.find(o => o.id === e.target.name)) {
        if (
          poeTestData.filter(o => test[o.id] && test[o.id] == true).length ==
          poeTestData.length
        ) {
          test["po-all"] = true;
        } else {
          test["po-all"] = false;
        }
      }
      if (fiberTestData.find(o => o.id === e.target.name)) {
        if (
          fiberTestData.filter(o => test[o.id] && test[o.id] == true).length ==
          fiberTestData.length
        ) {
          test["fb-all"] = true;
        } else {
          test["fb-all"] = false;
        }
      }
    }

    this.setState({ test, testCount, isSubTestError: false });
  };

  onChange = e => {
    const self = this;
    let test = { ...this.state.test };
    let cablemodels = self.state.cablemodels || [];
    let linkmodels = self.state.linkmodels || [];
    let cabletypes = self.state.cabletypes || [];
    let isNonGenericCableBrand = self.state.isNonGenericCableBrand;
    let errors = { ...this.state.errors };
    errors = {
      ...errors,
      [e.target.name]: false
    };
    if (
      e.target.name === "startvalue" &&
      e.target.value.trim() === "" &&
      test.startvalue === ""
    ) {
      return;
    }
    const { job, translate } = this.props;
    let value;
    if (
      job.metadatalookupid !== null &&
      job.metadatalookupid !== CUSTOM_METADATA_STANDARD
    ) {
      if (e.target.name === "floor")
        value =
          e.target.value.length <= 3 ? e.target.value : test[e.target.name];
      if (e.target.name === "telecommunicationspace")
        value =
          e.target.value.length <= 1 ? e.target.value : test[e.target.name];
      if (e.target.name === "panel")
        value =
          e.target.value.length <= 2 ? e.target.value : test[e.target.name];
      if (e.target.name === "startvalue")
        value =
          e.target.value.length <= 4 ? e.target.value : test[e.target.name];
      if (e.target.name === "endvalue")
        value =
          e.target.value.length <= 4 ? e.target.value : test[e.target.name];
    }

    if (e.target.name === "cablestandard") {
      const std = self.props.standards;
      const standard =
        std && std.cablestandards
          ? std.cablestandards.find(x => x.id == e.target.value)
          : null;
      self.setState({
        linkmodels: standard && standard.linkmodels ? standard.linkmodels : []
      });
      if (standard) {
        test.cablestandardname = standard.name;
      }
      if (test[e.target.name] && test[e.target.name] !== e.target.value) {
        test["linkmodel"] = "";
        test["cabletype"] = "";
        test["linkmodelname"] = "";
        test["cabletypename"] = "";
        self.setState({ cabletypes: [] });
      }
    }
    if (e.target.name === "linkmodel") {
      const linkModel = linkmodels
        ? linkmodels.find(x => x.id == e.target.value)
        : null;
      self.setState({
        cabletypes:
          linkModel && linkModel.cabletypes
            ? linkModel.cabletypes.sort(this.compare)
            : []
      });
      test.linkmodelname = linkModel ? linkModel.name : "";
      if (test[e.target.name] && test[e.target.name] !== e.target.value) {
        test["cabletype"] = "";
        test["cabletypename"] = "";
      }
    }

    if (e.target.name === "cabletype") {
      const cabletype = cabletypes
        ? cabletypes.find(x => x.id == e.target.value)
        : null;
      test.cabletypename = cabletype ? cabletype.name : "";
    }

    if (e.target.name === "cablebrand") {
      if (e.target.value) {
        const { standards } = self.props;
        const brand =
          standards && standards.cablebrands
            ? standards.cablebrands.find(x => x.id == e.target.value)
            : null;
        test.cablebrandname = brand ? brand.name : "";
        cablemodels = brand ? brand.cablemodels : [];
        if (brand && brand.name.toLowerCase() == "generic") {
          isNonGenericCableBrand = false;
        } else {
          isNonGenericCableBrand = true;
        }
      }
      test.nvp = 68;
      test.cableshielding = "U/UTP";
      test.cablemodelid = "";
      test.cablemodelname = "";
    }

    if (e.target.name === "connectorbrandnear") {
      if (e.target.value) {
        const conns = self.props.standards;
        const connectornear =
          conns && conns.connectorbrands
            ? conns.connectorbrands.find(x => x.id == e.target.value)
            : null;
        test.connectorbrandnearname = connectornear ? connectornear.name : "";
      }
    }

    if (e.target.name === "connectorbrandfar") {
      if (e.target.value) {
        const conns = self.props.standards;
        const connectorfar =
          conns && conns.connectorbrands
            ? conns.connectorbrands.find(x => x.id == e.target.value)
            : null;
        test.connectorbrandfarname = connectorfar ? connectorfar.name : "";
      }
    }

    if (e.target.name === "cablemodelid") {
      if (e.target.value) {
        const cablemodel = cablemodels
          ? cablemodels.find(cablemodel => cablemodel.id == e.target.value)
          : null;
        if (cablemodel) {
          if (
            cablemodel.nvp &&
            (cablemodel.nvp >= 50 && cablemodel.nvp <= 100)
          ) {
            test.nvp = cablemodel.nvp;
          } else {
            test.nvp = 68;
          }
          if (cablemodel.name) {
            test.cablemodelname = cablemodel.name;
          }

          if (cablemodel.screen) {
            test.cableshielding = "S/STP";
          } else {
            test.cableshielding = "U/UTP";
          }
        } else {
          test.nvp = 68;
          test.cableshielding = "U/UTP";
        }
      }
    }

    test[e.target.name] = value ? value : e.target.value;
    if (e.target.name === "startvalue") {
      test["endvalue"] = value ? value : e.target.value;
    }
    // if (e.target.name === "endvalue") {
    //   test["endvalue"] = value ? value : e.target.value;
    // }
    if (
      job.metadatalookupid !== null &&
      job.metadatalookupid !== CUSTOM_METADATA_STANDARD
    ) {
      test.prefix = `${test.floor}-${test.telecommunicationspace}-${test.panel}`;
    }

    if (
      this.state.testIDType == "sequential" &&
      test.startvalue &&
      test.endvalue &&
      test.prefix
    ) {
      let names = generateNames(
        test.prefix,
        test.startvalue,
        test.endvalue,
        2000,
        errors
      );
      if (names) {
        test.names = names;
        delete errors.startvalue;
        delete errors.endvalue;
      } else {
        errors.startvalue = `${translate("test_invalid_range")} [ ${translate(
          errors.startvalue
        )} ]`;
        errors.endvalue = `${translate("test_invalid_range")} [ ${translate(
          errors.endvalue
        )} ]`;
        if (this.state.testIDType != "import") test.names = null;
      }
    } else {
      if (this.state.testIDType != "import") test.names = null;
    }
    this.setState({ test, errors, cablemodels, isNonGenericCableBrand });
  };

  onToggleChange = (e, checked) => {
    let test = { ...this.state.test };
    test[e.target.name] = checked;
    this.setState({ test: test });
  };

  onCustomCheckChange = e => {
    let test = { ...this.state.test };
    let metadataOption = test.metadata.find(
      x => parseInt(x.level, 10) === parseInt(e.target.name, 10)
    );
    let enabled = !metadataOption.enabled;
    let idx = test.metadata.findIndex(
      x => parseInt(x.level, 10) === parseInt(e.target.name, 10)
    );
    metadataOption = {
      enabled: enabled,
      field: document.querySelector(`select[name="${e.target.name}"]`).value,
      value: ""
    };
    test.metadata[idx] = { ...test.metadata[idx], ...metadataOption };
    this.setState({ test: test });
  };

  onCustomChange = e => {
    let test = { ...this.state.test };

    let metadataOption = test.metadata.find(
      x => parseInt(x.level, 10) === parseInt(e.target.name, 10)
    );
    let field = e.target.value;
    let idx = test.metadata.findIndex(
      x => parseInt(x.level, 10) === parseInt(e.target.name, 10)
    );
    metadataOption = {
      field
    };
    test.metadata[idx] = { ...test.metadata[idx], ...metadataOption };
    this.setState({ test: test });
  };

  onChangeMetadataField = e => {
    let { test, errors } = { ...this.state };
    let field;
    const { custom } = this.props;
    let metadataOption = test.metadata.find(
      x => parseInt(x.level, 10) === parseInt(e.target.name, 10)
    );
    let value = e.target.value;
    let idx = test.metadata.findIndex(
      x => parseInt(x.level, 10) === parseInt(e.target.name, 10)
    );
    if (metadataOption.field == null) {
      field = custom.find(c => c.level == e.target.name).values[0].id;
      metadataOption = {
        value,
        field
      };
    } else {
      metadataOption = {
        value
      };
    }

    errors[e.target.name] = false;
    test.metadata[idx] = { ...test.metadata[idx], ...metadataOption };
    this.setState({ test, errors });
  };

  validate = currentTab => {
    const { test, tabPosition, testCount, tabs, testIDType } = this.state;
    const { job, translate } = this.props;
    let validationData = {};
    let errors = {};
    if (tabPosition < 2 || currentTab) {
      switch (currentTab || currentTab === 0 ? currentTab : tabPosition) {
        case 0:
          if (testIDType == "sequential") {
            if (
              job.metadatalookupid !== null &&
              job.metadatalookupid !== CUSTOM_METADATA_STANDARD
            ) {
              validationData = {
                floor: {
                  required: translate("formfield_error_general_required"),
                  length: {
                    value: 3,
                    message: translate("formfield_error_general_length", {
                      value: 3
                    })
                  },
                  type: {
                    value: "alphanumeric",
                    message: translate(
                      "formfield_error_general_type_alphanumeric"
                    )
                  }
                },
                telecommunicationspace: {
                  required: translate("formfield_error_general_required"),
                  length: {
                    value: 1,
                    message: translate("formfield_error_general_length", {
                      value: 1
                    })
                  },
                  type: {
                    value: "alphanumeric",
                    message: translate(
                      "formfield_error_general_type_alphanumeric"
                    )
                  }
                },
                panel: {
                  required: translate("formfield_error_general_required"),
                  length: {
                    value: 2,
                    message: translate("formfield_error_general_length", {
                      value: 2
                    })
                  },
                  type: {
                    value: "alphanumeric",
                    message: translate(
                      "formfield_error_general_type_alphanumeric"
                    )
                  }
                },
                startvalue: {
                  required: translate("formfield_error_general_required"),
                  length: {
                    value: 4,
                    message: translate("formfield_error_general_length", {
                      value: 4
                    })
                  },
                  type: {
                    value: "numeric",
                    message: translate("formfield_error_general_type_numeric")
                  }
                },
                endvalue: {
                  required: translate("formfield_error_general_required"),
                  length: {
                    value: 4,
                    message: translate("formfield_error_general_length", {
                      value: 4
                    })
                  },
                  type: {
                    value: "numeric",
                    message: translate("formfield_error_general_type_numeric")
                  }
                }
              };
            } else {
              validationData = {
                prefix: {
                  required: translate("formfield_error_general_required"),
                  type: {
                    value: "alphanumericspecial",
                    message: translate(
                      "formfield_error_general_type_alphanumeric"
                    )
                  }
                },
                startvalue: {
                  required: translate("formfield_error_general_required"),
                  type: {
                    value: "alphanumericspecial",
                    message: translate(
                      "formfield_error_general_type_alphanumeric"
                    )
                  }
                  // length: {
                  //   value: 4,
                  //   message: translate("formfield_error_general_length", {
                  //     value: 4
                  //   })
                  // }
                },
                endvalue: {
                  required: translate("formfield_error_general_required"),
                  type: {
                    value: "alphanumericspecial",
                    message: translate(
                      "formfield_error_general_type_alphanumeric"
                    )
                  }
                  // length: {
                  //   value: 4,
                  //   message: translate("formfield_error_general_length", {
                  //     value: 4
                  //   })
                  // }
                }
              };
            }
          }
          break;
        case 1:
          test.metadata.map(x => {
            if (x.enabled && x.field != null && x.value.trim() === "") {
              errors[x.level] = true;
            } else if (x.enabled && x.field != null && x.value.length > 12) {
              errors[x.level] = true;
            }
          });
          break;
        default:
          return true;
      }
      if (testIDType == "sequential" && tabPosition === 0) {
        if (!this.state.test.names) {
          errors.startvalue = `${translate("test_invalid_range")} [ ${translate(
            "test_maximum_allowed_range"
          )} ]`;
          errors.endvalue = `${translate("test_invalid_range")} [ ${translate(
            "test_maximum_allowed_range"
          )} ]`;
        }
      }

      if (
        (tabPosition === 1 &&
          job.metadatalookupid === CUSTOM_METADATA_STANDARD) ||
        (currentTab && job.metadatalookupid === CUSTOM_METADATA_STANDARD)
      ) {
      } else {
        errors = validateFormData(test, validationData);
      }

      if (
        testIDType == "sequential" &&
        test.startvalue &&
        test.endvalue &&
        test.prefix
      ) {
        let names = generateNames(
          test.prefix,
          test.startvalue,
          test.endvalue,
          2000,
          errors
        );
        if (names) {
          test.names = names;
          delete errors.startvalue;
          delete errors.endvalue;
        } else {
          errors.startvalue = `${translate("test_invalid_range")} [ ${translate(
            errors.startvalue
          )} ]`;
          errors.endvalue = `${translate("test_invalid_range")} [ ${translate(
            errors.endvalue
          )} ]`;
          if (testIDType != "import") test.names = null;
        }
      } else {
        if (testIDType != "import") test.names = null;
      }

      if (testIDType == "import" && tabPosition === 0) {
        delete errors.startvalue;
        delete errors.endvalue;
        delete errors.prefix;
        if (this.state.lantekfiles == null || this.state.test.names == null || this.state.test.names.length === 0) {
          errors.importFile = "Required";
        }
        else if (this.state.test.names.length > 2000) {
          errors.importFile = "LimitExceeded";
        }
        // validationData = {
        //   lantekfiles: {
        //     required: translate("formfield_error_general_required")
        //   }
        // };
      }

      const missingFieldName = Object.keys(errors)[0];
      if (missingFieldName) {
        const textField = document.getElementsByName(missingFieldName)[0];
        textField && textField.focus();

        if (Number.isInteger(parseInt(missingFieldName))) {
          toast.error(
            ` ${this.props.translate("test_create_invalid_identifier")}`,
            {
              position: toast.POSITION.TOP_CENTER,
              hideProgressBar: true
            }
          );
        }
      }
    }
    // else if (tabPosition == 5) {
    //   if (testCount <= 0) errors["subTests"] = "Required";
    // }
    if (Object.keys(errors).length) {
      if (!currentTab && currentTab !== 0) {
        this.setState({ errors });
      } else {
        this.setState({
          errors,
          tabPosition: currentTab,
          tabView: tabs[currentTab]
        });
      }
      return false;
    } else {
      this.setState({ errors });
      return true;
    }
  };

  createTests() {
    let isValidated = false;
    const { tabPosition, testCount } = this.state;
    for (let currentTab = 0; currentTab <= tabPosition; currentTab++) {
      isValidated = this.validate(currentTab);
      if (!isValidated) {
        return;
      }
    }
    if (isValidated) {
      let { test, testIDType } = this.state;
      const { job, pager, userPreference } = this.props;

      if (!test.nvp) {
        test = { ...test, nvp: 0 };
      }

      if (
        job.metadatalookupid !== null &&
        job.metadatalookupid !== CUSTOM_METADATA_STANDARD
      ) {
        test.prefix = `${test.floor}-${test.telecommunicationspace}-${test.panel}`;
      }

      //Remove Disabled Metadata
      if (job.metadatalookupid === CUSTOM_METADATA_STANDARD || (userPreference && userPreference.FromTreeview)) {
        let metadata = [...test.metadata];
        metadata.map(e => {
          if (!e.enabled) {
            e.field = "";
            e.value = "";
            return e;
          }
        });
        test.metadata = metadata;
      }
      if (job.metadatalookupid !== CUSTOM_METADATA_STANDARD && (userPreference && !userPreference.FromTreeview)) {
        var tempMetadata = test.metadata.map(i => {
          return { ...i, ...{ value: null } };
        });
        test = { ...test, metadata: tempMetadata };
      }
      this.props.type == "fiber"
        ? (test.interfaceid = 1)
        : (test.interfaceid = 0);
      if (testIDType === "import") {
        test.names = test.names.filter(
          (value, index) => test.names.indexOf(value) === index
        );
      }
      if (testCount <= 0) {
        this.setState({ isSubTestError: true });
      } else {
        this.setState({ isSubTestError: false });
        this.props.saveNewTests(test, pager);
      }
    }
  }

  addSubTestDetails = (type, details) => {
    let { test } = this.state;
    test[type + "details"] = details;
    this.setState({
      test
      //showRestore: true,
      // ping4Edit: true,
      // isDetailsUpdated: true
    });
    //this.onSubtestEditClose(type);
  };

  onTestPrefixTypeChange(e) {
    let test = { ...this.state.test };
    let testPrefixType = e.target.value;

    let errors = { ...this.state.errors };

    const { translate } = this.props;

    if (e.target.value !== "custom") {
      test.prefix =
        this.props.custom
          .find(cust => cust.level === 1)
          .values.find(obj => {
            return obj.id === e.target.value;
          }).name || "";
    } else {
      test.prefix = "";
    }
    if (test.startvalue && test.endvalue && test.prefix) {
      let names = generateNames(
        test.prefix,
        test.startvalue,
        test.endvalue,
        10000,
        errors
      );
      if (names) {
        test.names = names;
        delete errors.startvalue;
        delete errors.endvalue;
      } else {
        errors.startvalue = `${translate("test_invalid_range")} [ ${translate(
          errors.startvalue
        )} ]`;
        errors.endvalue = `${translate("test_invalid_range")} [ ${translate(
          errors.endvalue
        )} ]`;
        test.names = null;
      }
    } else {
      test.names = null;
    }
    this.setState({
      test,
      testPrefixType
    });
  }

  onSubtestEdit = type => {
    switch (type.id) {
      case "ping4":
        {
          this.setState({ ping4Edit: true, editModalOpen: true });
        }
        break;
      case "ping6":
        {
          this.setState({ ping6Edit: true, editModalOpen: true });
        }
        break;
      case "traceroute4":
        {
          this.setState({ traceroute4Edit: true, editModealOpen: true });
        }
        break;
      case "traceroute6":
        {
          this.setState({ traceroute6Edit: true, editModealOpen: true });
        }
        break;
      case "uptime":
        {
          this.setState({ uptimeEdit: true, editModalOpen: true });
        }
        break;
      case "netscan":
        {
          this.setState({ netscanEdit: true, editModealOpen: true });
        }
        break;
      case "poeload":
        {
          this.setState({ poeLoadEdit: true, editModealOpen: true });
        }
        break;
      case "wiremap":
        {
          this.setState({ wireMapEdit: true, editModalOpen: true });
        }
        break;
      case "maxthroughput":
        {
          this.setState({ maxthroughputEdit: true, editModalOpen: true });
        }
        break;
      case "customdata":
        {
          this.setState({ customdataEdit: true, editModalOpen: true });
        }
        break;
      case "cabledata":
        {
          this.setState({ cabledataEdit: true, editModalOpen: true });
        }
        break;
      case "webdata":
        {
          this.setState({ webdataEdit: true, editModalOpen: true });
        }
        break;
      case "voipdata":
        {
          this.setState({ voipdataEdit: true, editModalOpen: true });
        }
        break;
      case "videodata":
        {
          this.setState({ videodataEdit: true, editModalOpen: true });
        }
        break;
      case "cctvdata":
        {
          this.setState({ cctvdataEdit: true, editModalOpen: true });
        }
        break;
      case "fiberlengthloss":
        {
          this.setState({ fiberlengthlossEdit: true, editModalOpen: true });
        }
        break;
    }
  };

  onSubtestEditClose = type => {
    switch (type) {
      case "ping4":
        {
          this.setState({
            ping4Edit: false,
            editModalOpen: false
          });
        }
        break;
      case "ping6":
        {
          this.setState({
            ping6Edit: false,
            editModalOpen: false
          });
        }
        break;
      case "traceroute4":
        {
          this.setState({ traceroute4Edit: false, editModealOpen: false });
        }
        break;
      case "traceroute6":
        {
          this.setState({ traceroute6Edit: false, editModealOpen: false });
        }
        break;
      case "uptime":
        {
          this.setState({ uptimeEdit: false, editModalOpen: false });
        }
        break;
      case "netscan":
        {
          this.setState({ netscanEdit: false, editModealOpen: false });
        }
        break;
      case "poeload":
        {
          this.setState({ poeLoadEdit: false, editModealOpen: false });
        }
        break;
      case "wiremap":
        {
          this.setState({ wireMapEdit: false, editModalOpen: false });
        }
        break;
      case "maxthroughput":
        {
          this.setState({ maxthroughputEdit: false, editModalOpen: false });
        }
        break;
      case "customdata":
        {
          this.setState({ customdataEdit: false, editModalOpen: false });
        }
        break;
      case "cabledata":
        {
          this.setState({ cabledataEdit: false, editModalOpen: false });
        }
        break;
      case "webdata":
        {
          this.setState({ webdataEdit: false, editModalOpen: false });
        }
        break;
      case "voipdata":
        {
          this.setState({ voipdataEdit: false, editModalOpen: false });
        }
        break;
      case "videodata":
        {
          this.setState({ videodataEdit: false, editModalOpen: false });
        }
        break;
      case "cctvdata":
        {
          this.setState({ cctvdataEdit: false, editModalOpen: false });
        }
        break;
      case "fiberlengthloss":
        {
          this.setState({ fiberlengthlossEdit: false, editModalOpen: false });
        }
        break;
    }
  };

  deleteDefaultSubtests = type => {
    let updateTest = this.state.test;
    delete updateTest[type + "details"];
    this.setState({ test: updateTest });
  };

  onRestoreDetails = type => {
    this.props.getPingDetails(type);
    //this.setState({ isDetailsUpdated: false });
  };

  onTestIDTypeChange = e => {
    let { errors } = { ...this.state };
    let test = { ...this.state.test };
    //this.setState({ testIDType: e.target.value });
    if (e.target.value == "import") {
      errors.startvalue = false;
      errors.endvalue = false;
      errors.prefix = false;
    }
    errors.importFile = false;
    test.names = null;
    test.prefix = "";
    test.startvalue = "01";
    test.endvalue = "24";
    this.setState({
      testIDType: e.target.value,
      errors,
      test,
      testPrefixType: "custom",
      lantekfiles: null
    });
  };

  handleUpload() {
    let fd = new FormData();
    let lantekfiles = { ...this.state.lantekfiles };
    let { errors } = { ...this.state };
    Object.keys(lantekfiles).forEach(key => {
      fd.append("file", lantekfiles[key]);
    });
    errors.importFile = false;
    //alert("test");
    this.props.clearDuplicateError();
    this.props.uploadTestIDFile(fd);
    this.setState({
      errors
    });
    // this.props
    //   .uploadTestIDFile(fd)
    //   .then(resp => {
    //     // self.closeUploadLantekModal();
    //     // self.closeImportTestModal();
    //   })
    //   .catch(errors => {
    //     console.log("ERRRRRRR" + errors);
    //   });
  }

  handleImport(e) {
    let { errors } = { ...this.state };
    errors.importFile = false;
    this.setState({
      errors
    });
    if (e.target.type == "file" && e.target.files.length) {
      // const totalBytes = Object.keys(e.target.files).reduce(
      //   (total, file) => total + e.target.files[file].size,
      //   0
      // );
      // 1 MB = 1048576 bytes
      // if (Math.round(totalBytes / 1048576) >= APP_CONFIG.maxFileUploadSize) {
      //   toast.error(
      //     ` ${this.props.translate(
      //       "jobs_upload_lantek_files_large_filesize_unsuccessfull_toast"
      //     )}`,
      //     {
      //       position: toast.POSITION.TOP_CENTER,
      //       hideProgressBar: true
      //     }
      //   );
      //   document.getElementById("lantekfiles").value = "";
      //   this.setState({
      //     lantekfiles: null,
      //     testFileArray: null,
      //     jobFileArray: null
      //   });
      //   return;
      // }
      this.setState({
        [e.target.name]: e.target.files
        // testFileArray: Array.from(e.target.files).filter(
        //   file =>
        //     file.name
        //       .split(".")
        //       .pop()
        //       .toLowerCase() !== "job"
        // ),
        // jobFileArray: Array.from(e.target.files).filter(
        //   file =>
        //     file.name
        //       .split(".")
        //       .pop()
        //       .toLowerCase() === "job"
        // )
      });
    }
  }

  render() {
    const { classes, translate, job, lengthMeasurementUnit } = this.props;

    let {
      custom,
      standards,
      error,
      type,
      userPreference,
      IDerrors
    } = this.props;

    let metadataOption;
    const {
      test,
      errors,
      tabs,
      testPrefixType,
      tabPosition,
      disabledToogleIdentifier,
      cablemodels,
      linkmodels,
      cabletypes,
      isNonGenericCableBrand,
      isSubTestError,
      tabView,
      customerTargets4,
      customerTargets6,
      selectedTestResult,
      selectedTrResult,
      editModalOpen,
      ping4Edit,
      ping6Edit,
      editModealOpen,
      traceroute6Edit,
      traceroute4Edit,
      uptimeEdit,
      upTime,
      netscanEdit,
      isDetailsUpdated,
      netScan,
      //showRestore,
      poeLoadEdit,
      customerPoELoad,
      wireMapEdit,
      wireMap,
      cableList,
      maxThroughPut,
      maxthroughputEdit,
      subtestSettings,
      customdataEdit,
      cabledataEdit,
      webdataEdit,
      voipdataEdit,
      videodataEdit,
      cctvdataEdit,
      fiberlengthlossEdit,
      testIDType,
      lantekfiles,
      modalRef
    } = this.state;

    let cablestandards, cablebrands, connectorbrands;

    if (standards) {
      cablestandards = standards.cablestandards;
      cablebrands = standards.cablebrands;
      connectorbrands = standards.connectorbrands;
    }

    let $fiberlengthlossEditModal = null;
    if (editModalOpen) {
      if (fiberlengthlossEdit) {
        $fiberlengthlossEditModal = (
          <FiberLengthLossEdit
            selectedTest={"fiberlengthloss"}
            translate={this.props.translate}
            getFiberLengthLoss={this.props.getFiberLengthLoss}
            fiberLengthLoss={this.props.fiberLengthLoss}
            updateFiberLengthLoss={this.addSubTestDetails}
            isModalOpen={editModalOpen}
            fiberlengthlossDetails={test["fiberlengthlossdetails"]}
            handleClose={this.onSubtestEditClose}
            deleteDefaultSubtests={this.deleteDefaultSubtests}
            testCreationClose={this.handleClose}
            customerId={job.customerid}
            lengthMeasurementUnit={lengthMeasurementUnit}
          />
        );
      } else {
        $fiberlengthlossEditModal = null;
      }
    }

    let $uptimeEditModal = null;
    if (editModalOpen) {
      if (uptimeEdit) {
        $uptimeEditModal = (
          <UpTimeEdit
            selectedTest={"uptime"}
            upTime={this.props.upTime}
            translate={this.props.translate}
            getUpTime={this.props.getUpTime}
            updateUpTime={this.addSubTestDetails}
            isModalOpen={editModalOpen}
            uptimeDetails={test["uptimedetails"]}
            handleClose={this.onSubtestEditClose}
            deleteDefaultSubtests={this.deleteDefaultSubtests}
            testCreationClose={this.handleClose}
            customerId={job.customerid}
          />
        );
      } else {
        $uptimeEditModal = null;
      }
    }
    let $netScanEditModal = null;
    if (editModealOpen) {
      if (netscanEdit) {
        $netScanEditModal = (
          <NetScanEdit
            selectedTest={"netscan"}
            netScan={this.props.netScan}
            translate={this.props.translate}
            getNetScan={this.props.getNetScan}
            updateNetScan={this.addSubTestDetails}
            isModalOpen={editModealOpen}
            netscanDetails={test["netscandetails"]}
            handleClose={this.onSubtestEditClose}
            deleteDefaultSubtests={this.deleteDefaultSubtests}
            testCreationClose={this.handleClose}
            customerId={job.customerid}
          />
        );
      } else {
        $netScanEditModal = null;
      }
    }

    let $wireMapEditModal = null;
    if (editModalOpen) {
      if (wireMapEdit) {
        $wireMapEditModal = (
          <WireMapEdit
            selectedTest={"wiremap"}
            translate={this.props.translate}
            getWireMap={this.props.getWireMap}
            getCableList={this.props.getCableList}
            wireMap={this.props.wireMap}
            cableList={this.props.cableList}
            updateWireMap={this.addSubTestDetails}
            isModalOpen={editModalOpen}
            wiremapDetails={test["wiremapdetails"]}
            handleClose={this.onSubtestEditClose}
            deleteDefaultSubtests={this.deleteDefaultSubtests}
            testCreationClose={this.handleClose}
            customerId={job.customerid}
          />
        );
      } else {
        $wireMapEditModal = null;
      }
    }

    let $maxthroughputEditModal = null;
    if (editModalOpen) {
      if (maxthroughputEdit) {
        $maxthroughputEditModal = (
          <MaxthroughputEdit
            selectedTest={"maxthroughput"}
            translate={this.props.translate}
            getMaxThroughPut={this.props.getMaxThroughPut}
            maxThroughPut={this.props.maxThroughPut}
            updateMaxThroughPut={this.addSubTestDetails}
            isModalOpen={editModalOpen}
            maxthroughputDetails={test["maxthroughputdetails"]}
            handleClose={this.onSubtestEditClose}
            deleteDefaultSubtests={this.deleteDefaultSubtests}
            testCreationClose={this.handleClose}
            customerId={job.customerid}
          />
        );
      } else {
        $maxthroughputEditModal = null;
      }
    }

    let $poeLoadEditModal = null;
    if (editModealOpen) {
      if (poeLoadEdit) {
        $poeLoadEditModal = (
          <PoELoadEdit
            selectedTest={"poeload"}
            translate={this.props.translate}
            customerPoELoad={this.props.customerPoELoad}
            getCustPoELoad={this.props.getCustPoELoad}
            updateCustPoELoad={this.addSubTestDetails}
            poeLoadDetails={test["poeloaddetails"]}
            handleClose={this.onSubtestEditClose}
            deleteDefaultSubtests={this.deleteDefaultSubtests}
            testCreationClose={this.handleClose}
            customerId={job.customerid}
          />
        );
      } else {
        $poeLoadEditModal = null;
      }
    }

    let $customDataEditModal = null;
    if (editModalOpen) {
      if (customdataEdit) {
        $customDataEditModal = (
          <CustomDataEdit
            selectedTest={"customdata"}
            translate={this.props.translate}
            subtestSettings={this.props.subtestSettings}
            getSubtestSettings={this.props.getSubtestSettings}
            updateSubTestSettings={this.addSubTestDetails}
            customdataDetails={test["customdatadetails"]}
            handleClose={this.onSubtestEditClose}
            deleteDefaultSubtests={this.deleteDefaultSubtests}
            testCreationClose={this.handleClose}
            customerId={job.customerid}
          />
        );
      } else {
        $customDataEditModal = null;
      }
    }

    let $cableDataEditModal = null;
    if (editModalOpen) {
      if (cabledataEdit) {
        $cableDataEditModal = (
          <CableDataEdit
            selectedTest={"cabledata"}
            translate={this.props.translate}
            subtestSettings={this.props.subtestSettings}
            getSubtestSettings={this.props.getSubtestSettings}
            updateSubTestSettings={this.addSubTestDetails}
            cabledataDetails={test["cabledatadetails"]}
            handleClose={this.onSubtestEditClose}
            deleteDefaultSubtests={this.deleteDefaultSubtests}
            testCreationClose={this.handleClose}
            customerId={job.customerid}
          />
        );
      } else {
        $cableDataEditModal = null;
      }
    }

    let $webDataEditModal = null;
    if (editModalOpen) {
      if (webdataEdit) {
        $webDataEditModal = (
          <WebDataEdit
            selectedTest={"webdata"}
            translate={this.props.translate}
            subtestSettings={this.props.subtestSettings}
            getSubtestSettings={this.props.getSubtestSettings}
            updateSubTestSettings={this.addSubTestDetails}
            webdataDetails={test["webdatadetails"]}
            handleClose={this.onSubtestEditClose}
            deleteDefaultSubtests={this.deleteDefaultSubtests}
            testCreationClose={this.handleClose}
            customerId={job.customerid}
          />
        );
      } else {
        $webDataEditModal = null;
      }
    }

    let $voipDataEditModal = null;
    if (editModalOpen) {
      if (voipdataEdit) {
        $voipDataEditModal = (
          <VoipDataEdit
            selectedTest={"voipdata"}
            translate={this.props.translate}
            subtestSettings={this.props.subtestSettings}
            getSubtestSettings={this.props.getSubtestSettings}
            updateSubTestSettings={this.addSubTestDetails}
            voipdataDetails={test["voipdatadetails"]}
            handleClose={this.onSubtestEditClose}
            deleteDefaultSubtests={this.deleteDefaultSubtests}
            testCreationClose={this.handleClose}
            customerId={job.customerid}
          />
        );
      } else {
        $voipDataEditModal = null;
      }
    }

    let $videoDataEditModal = null;
    if (editModalOpen) {
      if (videodataEdit) {
        $videoDataEditModal = (
          <VideoDataEdit
            selectedTest={"videodata"}
            translate={this.props.translate}
            subtestSettings={this.props.subtestSettings}
            getSubtestSettings={this.props.getSubtestSettings}
            updateSubTestSettings={this.addSubTestDetails}
            videodataDetails={test["videodatadetails"]}
            handleClose={this.onSubtestEditClose}
            deleteDefaultSubtests={this.deleteDefaultSubtests}
            testCreationClose={this.handleClose}
            customerId={job.customerid}
          />
        );
      } else {
        $videoDataEditModal = null;
      }
    }

    let $cctvDataEditModal = null;
    if (editModalOpen) {
      if (cctvdataEdit) {
        $cctvDataEditModal = (
          <CCTVDataEdit
            selectedTest={"cctvdata"}
            translate={this.props.translate}
            subtestSettings={this.props.subtestSettings}
            getSubtestSettings={this.props.getSubtestSettings}
            updateSubTestSettings={this.addSubTestDetails}
            cctvdataDetails={test["cctvdatadetails"]}
            handleClose={this.onSubtestEditClose}
            deleteDefaultSubtests={this.deleteDefaultSubtests}
            testCreationClose={this.handleClose}
            customerId={job.customerid}
          />
        );
      } else {
        $cctvDataEditModal = null;
      }
    }

    let $tracerouteEditModal = null;
    if (editModealOpen) {
      if (traceroute6Edit) {
        $tracerouteEditModal = (
          <TREdit
            selectedTest={"traceroute6"}
            translate={this.props.translate}
            selectedTrResult={this.props.selectedTrResult}
            subTestTargetResult={this.props.customerTargets6}
            getTrDetails={this.props.getTrDetails}
            updateTrDetails={this.addSubTestDetails}
            getPingTargetList={this.props.getCustTargets6}
            isModalOpen={editModealOpen}
            traceroute6Details={test["traceroute6details"]}
            handleClose={this.onSubtestEditClose}
            deleteDefaultSubtests={this.deleteDefaultSubtests}
            testCreationClose={this.handleClose}
            customerId={job.customerid}
          />
        );
      } else if (traceroute4Edit) {
        $tracerouteEditModal = (
          <TREdit
            selectedTest={"traceroute4"}
            translate={this.props.translate}
            selectedTrResult={this.props.selectedTrResult}
            subTestTargetResult={this.props.customerTargets4}
            getTrDetails={this.props.getTrDetails}
            updateTrDetails={this.addSubTestDetails}
            traceroute4Details={test["traceroute4details"]}
            getPingTargetList={this.props.getCustTargets4}
            isModalOpen={editModealOpen}
            handleClose={this.onSubtestEditClose}
            deleteDefaultSubtests={this.deleteDefaultSubtests}
            testCreationClose={this.handleClose}
            customerId={job.customerid}
          />
        );
      }
    } else {
      $tracerouteEditModal = null;
    }
    if (!custom) return null;

    custom = custom.sort((a, b) => b.level > a.level);
    let showAllMetadataSwitch =
      this.state.test.metadata.filter(n => n.field).length !== 6;

    let $editModal = null;
    if (editModalOpen) {
      if (ping4Edit) {
        $editModal = (
          <PINGEdit
            selectedTest={"ping4"}
            translate={this.props.translate}
            selectedTestResult={this.props.selectedTestResult}
            subTestTargetResult={this.props.customerTargets4}
            getPingDetails={this.props.getPingDetails}
            getPingTargetList={this.props.getCustTargets4}
            updateTestPingDetails={this.addSubTestDetails}
            isModalOpen={editModalOpen}
            isTestEdit={true}
            handleClose={this.onSubtestEditClose}
            //showRestore={showRestore}
            onRestoreDetails={this.onRestoreDetails}
            ping4Edit={ping4Edit}
            ping4Details={test["ping4details"]}
            onTestCreateClose={this.handleClose}
            deleteDefaultSubtests={this.deleteDefaultSubtests}
            customerId={job.customerid}
          />
        );
      }
      if (ping6Edit) {
        $editModal = (
          <PINGEdit
            selectedTest={"ping6"}
            translate={this.props.translate}
            selectedTestResult={this.props.selectedTestResult}
            subTestTargetResult={this.props.customerTargets6}
            getPingDetails={this.props.getPingDetails}
            getPingTargetList={this.props.getCustTargets6}
            updateTestPingDetails={this.addSubTestDetails}
            isModalOpen={editModalOpen}
            isTestEdit={true}
            handleClose={this.onSubtestEditClose}
            //showRestore={showRestore}
            onRestoreDetails={this.onRestoreDetails}
            ping4Edit={ping4Edit}
            ping6Details={test["ping6details"]}
            onTestCreateClose={this.handleClose}
            deleteDefaultSubtests={this.deleteDefaultSubtests}
            customerId={job.customerid}
          />
        );
      }
    }
    return (
      <Modal open={this.props.open} onClose={this.handleClose}>
        <div className={classes.root}>
          <Paper className={classes.modal}>
            <ModalHeader>
              <Typography type="headline" color="inherit">
                {translate("test_add")}
              </Typography>
              <Button className={classes.close} onClick={this.handleClose}>
                <Icon>clear</Icon>
              </Button>
            </ModalHeader>

            <ModalContents>
              {$editModal}
              {$uptimeEditModal}
              {error && error === "error_duplicatetest" && (
                <Paper className={classes.error} elevation={0}>
                  <Typography
                    variant="headline"
                    component="h3"
                    color="secondary"
                  >
                    {translate("test_duplicate_error")}
                  </Typography>
                  <Typography component="p" color="secondary">
                    {translate("test_duplicate_error_desc")}
                  </Typography>
                </Paper>
              )}
              {error && error === "error_testnamesize_exceeds_80chars" && (
                <Paper className={classes.error} elevation={0}>
                  <Typography
                    variant="headline"
                    component="h3"
                    color="secondary"
                  >
                    {translate("import_test_ids_invalid_length")}
                  </Typography>
                </Paper>
              )}
              {error && error === "nvp_out_of_range" && (
                <Paper className={classes.error} elevation={0}>
                  <Typography
                    variant="headline"
                    component="h3"
                    color="secondary"
                  >
                    {translate("test_nvp_out_of_range")}
                  </Typography>
                  <Typography component="p" color="secondary">
                    {translate("test_nvp_out_of_range_desc", { min: 58, max: 89 })}
                  </Typography>
                </Paper>
              )}
              {IDerrors && IDerrors === "invalid_character" && (
                <Paper className={classes.error} elevation={0}>
                  <Typography
                    variant="headline"
                    component="h3"
                    color="secondary"
                  >
                    {translate("import_test_ids_invalid_header")}
                  </Typography>
                  <Typography component="p" color="secondary">
                    {translate("import_test_ids_invalid_char")}
                  </Typography>
                </Paper>
              )}
              {IDerrors && IDerrors === "maximum_length_exceed" && (
                <Paper className={classes.error} elevation={0}>
                  <Typography
                    variant="headline"
                    component="h3"
                    color="secondary"
                  >
                    {translate("import_test_ids_invalid_header")}
                  </Typography>
                  <Typography component="p" color="secondary">
                    {translate("import_test_ids_invalid_length")}
                  </Typography>
                </Paper>
              )}
              {IDerrors && IDerrors === "too_many_test_to_import" && (
                <Paper className={classes.error} elevation={0}>
                  <Typography
                    variant="headline"
                    component="h3"
                    color="secondary"
                  >
                    {translate("import_test_ids_invalid_header")}
                  </Typography>
                  <Typography component="p" color="secondary">
                    {translate("import_test_ids_invalid_numbers")}
                  </Typography>
                </Paper>
              )}
              {IDerrors && IDerrors === "error_wrongfiletype" && (
                <Paper className={classes.error} elevation={0}>
                  <Typography
                    variant="headline"
                    component="h3"
                    color="secondary"
                  >
                    {translate("import_test_ids_invalid_header")}
                  </Typography>
                  <Typography component="p" color="secondary">
                    {translate("import_test_ids_invalid_type")}
                  </Typography>
                </Paper>
              )}
              {IDerrors && IDerrors === "error_duplicatetest" && (
                <Paper className={classes.error} elevation={0}>
                  <Typography
                    variant="headline"
                    component="h3"
                    color="secondary"
                  >
                    {translate("import_test_ids_invalid_header")}
                  </Typography>
                  <Typography component="p" color="secondary">
                    {translate("test_duplicate_error_desc")}
                  </Typography>
                </Paper>
              )}
              {$tracerouteEditModal}
              {$netScanEditModal}
              {$poeLoadEditModal}
              {$wireMapEditModal}
              {$maxthroughputEditModal}
              {$customDataEditModal}
              {$cableDataEditModal}
              {$webDataEditModal}
              {$voipDataEditModal}
              {$videoDataEditModal}
              {$cctvDataEditModal}
              {$fiberlengthlossEditModal}
              <form noValidate autoComplete="off" className={classes.form} ref={modalRef}>
                <Tabs value={tabPosition} onChange={this.handleTabChange}>
                  {tabs.map((tab, index) => {
                    return <Tab key={index} label={translate(tab)} />;
                  })}
                </Tabs>
                {tabView === "tab_details" && (
                  <div className={classes.summary}>
                    {(job.metadatalookupid === null ||
                      job.metadatalookupid === CUSTOM_METADATA_STANDARD || (userPreference && userPreference.FromTreeview)) && (
                      <div>
                        <FormControl>
                          <RadioGroup
                            aria-label="chartLine"
                            name="chartLine"
                            className={classes.group}
                            value={testIDType}
                            onChange={this.onTestIDTypeChange}
                            row={true}
                          >
                            <FormControlLabel
                              value="sequential"
                              control={<Radio />}
                              label={translate("sequential_test_ids")}
                            />
                            <FormControlLabel
                              value="import"
                              control={<Radio />}
                              label={translate("import_test_ids")}
                            />
                          </RadioGroup>
                        </FormControl>
                        {testIDType === "import" && (
                          <div>
                            {/* <form
                              noValidate
                              autoComplete="off"
                              className={classes.form_inner}
                            > */}
                            <div className={classes.uploadlabel}>
                              <InputLabel
                                htmlFor="testPrefixType"
                                className={classes.fileUpload}
                              >
                                {translate("select_spreadsheet_to_import")}
                              </InputLabel>
                            </div>
                            <FormControl
                              fullWidth
                              error={errors.lantekfiles ? true : false}
                            >
                              <Input
                                className={classes.upload}
                                id="lantekfiles"
                                type="file"
                                name="lantekfiles"
                                onChange={this.handleImport}
                                inputProps={{
                                  name: "lantekfiles",
                                  multiple: false,
                                  accept: ".xlsx,.csv"
                                }}
                                error={errors.lantekfiles ? true : false}
                                helperText={
                                  errors.lantekfiles
                                    ? errors.lantekfiles
                                    : 'translate("test_custom_prefix_help")'
                                }
                              />
                              {/* <FormHelperText id="lantekfiles-helper-text">
                              {"Please Select a single file."}
                            </FormHelperText> */}
                            </FormControl>
                            {/* </form> */}
                            <Button
                              className={classes.import}
                              error={errors.importFile ? true : false}
                              raised
                              color="primary"
                              onClick={this.handleUpload}
                              disabled={lantekfiles == null}
                              helperText={
                                errors.importFile
                                  ? errors.importFile
                                  : 'translate("test_custom_prefix_help")'
                              }
                            >
                              {translate("general_import").toUpperCase()}
                            </Button>
                            {/* {$fileLists}
                          {$jobFile} */}
                            <HtmlTooltip
                              title={
                                <React.Fragment>
                                  <ul>
                                    <li>{translate("test_ids_tooltip_1")}</li>
                                    <li>{translate("test_ids_tooltip_2")}</li>
                                    <li>{translate("test_ids_tooltip_3")}</li>
                                    <li>{translate("test_ids_tooltip_4")}</li>
                                  </ul>
                                </React.Fragment>
                              }
                            >
                              <div className={classes.tooltip}>[?]</div>
                            </HtmlTooltip>
                            {(errors.importFile === "Required") && (
                              <Typography className={classes.uploadValidation}>
                                {translate("import_test_ids_required")}
                              </Typography>
                            )}
                            {(errors.importFile === "LimitExceeded") && (
                              <Typography className={classes.uploadValidation}>
                                {translate("import_test_ids_limit_exceeded")}
                              </Typography>
                            )}
                          </div>
                        )}
                        {testIDType === "sequential" && (
                          <FormControl
                            className={classes.textField}
                            margin="normal"
                          >
                            <InputLabel htmlFor="testPrefixType">
                              {translate("test_prefix")}
                            </InputLabel>
                            <Select
                              value={testPrefixType}
                              onChange={this.onTestPrefixTypeChange.bind(this)}
                              input={
                                <Input
                                  name="testPrefixType"
                                  id="testPrefixType"
                                  value={testPrefixType}
                                />
                              }
                              fullWidth
                            >
                              {custom
                                ? custom
                                    .find(c => c.level === 1)
                                    .values.map((c, index) => {
                                      return (
                                        <MenuItem
                                          key={`testPrefixType-${index}`}
                                          value={c.id}
                                        >
                                          {c.name}
                                        </MenuItem>
                                      );
                                    })
                                : null}
                              <MenuItem
                                key="testPrefixTypeCustom"
                                value="custom"
                              >
                                {translate("test_custom")}
                              </MenuItem>
                            </Select>
                            <FormHelperText>
                              {errors.cablestandard
                                ? errors.cablestandard
                                : translate("test_prefix_help")}
                            </FormHelperText>
                          </FormControl>
                        )}
                        {testIDType === "sequential" &&
                          testPrefixType === "custom" && (
                            <TextField
                              error={errors.prefix ? true : false}
                              required
                              name="prefix"
                              label={translate("test_custom_prefix")}
                              margin="normal"
                              fullWidth
                              value={test.prefix}
                              onChange={this.onChange}
                              inputProps={{
                                maxlength: 76
                              }}
                              helperText={
                                errors.prefix
                                  ? errors.prefix
                                  : translate("test_custom_prefix_help")
                              }
                            />
                          )}
                        {testIDType === "sequential" && (
                          <TextField
                            error={errors.startvalue ? true : false}
                            required
                            name="startvalue"
                            label={translate("test_startvalue")}
                            margin="normal"
                            fullWidth
                            value={test.startvalue}
                            onChange={this.onChange}
                            helperText={
                              errors.startvalue
                                ? errors.startvalue
                                : translate("test_startvalue_help")
                            }
                          />
                        )}
                        {testIDType === "sequential" && (
                          <TextField
                            error={errors.endvalue ? true : false}
                            required
                            name="endvalue"
                            label={translate("test_endvalue")}
                            margin="normal"
                            fullWidth
                            value={test.endvalue}
                            onChange={this.onChange}
                            helperText={
                              errors.endvalue
                                ? errors.endvalue
                                : translate("test_endvalue_help")
                            }
                          />
                        )}
                        {test.names && (
                          <React.Fragment>
                            <Grid container className={classes.testRange}>
                              <Grid item xs={12} sm={6}>
                                <Typography type="caption">
                                  {translate("test_ranges")}
                                </Typography>
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <Typography type="caption" align="right">
                                  {translate("test_ranges_total")} -
                                  <strong
                                    style={{ color: "rgba(0, 0, 0, 0.87)" }}
                                  >
                                    {test.names.length}
                                  </strong>
                                </Typography>
                              </Grid>
                            </Grid>
                            <List
                              disablePadding={true}
                              className={classes.scrollableList}
                            >
                              {test.names.map((val, i) => {
                                return (
                                  <ListItem key={`testnames-${i}`}>
                                    <ListItemText primary={val} />
                                  </ListItem>
                                );
                              })}
                            </List>
                          </React.Fragment>
                        )}
                      </div>
                    )}
                    {job.metadatalookupid &&
                      job.metadatalookupid !== CUSTOM_METADATA_STANDARD && (
                        <div>
                          <div className={classes.summary}>
                            <TextField
                              error={errors.floor ? true : false}
                              required
                              name="floor"
                              label={translate("test_floor")}
                              margin="normal"
                              fullWidth
                              value={test.floor}
                              onChange={this.onChange}
                              helperText={
                                errors.floor
                                  ? errors.floor
                                  : translate("test_floor_help")
                              }
                            />

                            <TextField
                              error={
                                errors.telecommunicationspace ? true : false
                              }
                              required
                              name="telecommunicationspace"
                              label={translate("test_telecommunicationspace")}
                              margin="normal"
                              fullWidth
                              value={test.telecommunicationspace}
                              onChange={this.onChange}
                              helperText={
                                errors.telecommunicationspace
                                  ? errors.telecommunicationspace
                                  : translate(
                                      "test_telecommunicationspace_help"
                                    )
                              }
                            />
                            <TextField
                              error={errors.panel ? true : false}
                              required
                              name="panel"
                              label={translate("test_panel")}
                              margin="normal"
                              fullWidth
                              value={test.panel}
                              onChange={this.onChange}
                              helperText={
                                errors.panel
                                  ? errors.panel
                                  : translate("test_panel_help")
                              }
                            />

                            <TextField
                              error={errors.startvalue ? true : false}
                              required
                              name="startvalue"
                              label={translate("test_portstartvalue")}
                              margin="normal"
                              fullWidth
                              value={test.startvalue}
                              onChange={this.onChange}
                              helperText={
                                errors.startvalue
                                  ? errors.startvalue
                                  : translate("test_portstartvalue_help")
                              }
                            />
                            <TextField
                              error={errors.endvalue ? true : false}
                              required
                              name="endvalue"
                              label={translate("test_portendvalue")}
                              margin="normal"
                              fullWidth
                              value={test.endvalue}
                              onChange={this.onChange}
                              helperText={
                                errors.endvalue
                                  ? errors.endvalue
                                  : translate("test_portendvalue_help")
                              }
                            />
                          </div>
                          {test.names && (
                            <React.Fragment>
                              <Grid container>
                                <Grid item xs={12} sm={6}>
                                  <Typography type="caption">
                                    {translate("test_ranges")}
                                  </Typography>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                  <Typography type="caption" align="right">
                                    {translate("test_ranges_total")}
                                    {test.names.length}
                                  </Typography>
                                </Grid>
                              </Grid>
                              <List
                                disablePadding={true}
                                className={classes.scrollableList}
                              >
                                {test.names.map((val, i) => {
                                  return (
                                    <ListItem key={`testnames-${i}`}>
                                      <ListItemText primary={val} />
                                    </ListItem>
                                  );
                                })}
                              </List>
                            </React.Fragment>
                          )}
                        </div>
                      )}
                  </div>
                )}

                {(job.metadatalookupid === CUSTOM_METADATA_STANDARD || (userPreference && userPreference.FromTreeview)) &&
                  tabView === "tab_identifiers" && (
                    <div className={classes.summary}>
                      {showAllMetadataSwitch && (
                        <Typography type="subheading">
                          <FormControlLabel
                            control={
                              <Switch
                                name="allmetadataoptions"
                                checked={test.allmetadataoptions}
                                onChange={(e, checked) =>
                                  this.onToggleChange(e, checked)
                                }
                                disabled={disabledToogleIdentifier}
                              />
                            }
                            label={translate("test_add_metadata_item")}
                          />
                        </Typography>
                      )}

                      {custom &&
                        custom
                          .sort((a, b) => {
                            return a.level > b.level
                              ? -1
                              : a.level < b.level
                              ? 1
                              : 0;
                          })
                          .map((c, index) => {
                            metadataOption = test.metadata.find(
                              x =>
                                parseInt(x.level, 10) === parseInt(c.level, 10)
                            );
                            return (test.allmetadataoptions ||
                              metadataOption.default ||
                              metadataOption.enabled) &&
                              c.level !== 1 ? (
                              <div key={index}>
                                <Checkbox
                                  name={c.level}
                                  checked={metadataOption.enabled}
                                  onChange={this.onCustomCheckChange}
                                />
                                <select
                                  name={c.level}
                                  value={metadataOption.field}
                                  onChange={this.onCustomChange}
                                  disabled={!metadataOption.enabled}
                                >
                                  {c.values.map((o, index) => {
                                    return (
                                      <option key={index} value={o.id}>
                                        {o.name}
                                      </option>
                                    );
                                  })}
                                </select>
                                <TextField
                                  error={errors[c.level] ? true : false}
                                  required
                                  name={c.level}
                                  margin="normal"
                                  value={metadataOption.value}
                                  onChange={this.onChangeMetadataField}
                                  disabled={!metadataOption.enabled}
                                />
                              </div>
                            ) : null;
                          })}
                    </div>
                  )}
                {tabView === "tab_network" && (
                  <FormGroup>
                    {nwTestData
                      ? nwTestData.map((item, index) => {
                          return (
                            <div>
                              <FormControlLabel
                                className={classes.textFieldL}
                                control={
                                  <Checkbox
                                    name={item.id}
                                    checked={
                                      test[item.id] == true ? true : false
                                    }
                                    onChange={this.onSubtestChange}
                                    value={
                                      test[item.id] ? test[item.id] : false
                                    }
                                    color="primary"
                                  />
                                }
                                label={
                                  <Typography className={classes.lookup}>
                                    {translate(item.id)}
                                    {test.hasOwnProperty(
                                      item.id + "details"
                                    ) ? (
                                      <Chip
                                        className={classes.chip}
                                        size="small"
                                        label={
                                          <Typography
                                            className={classes.chipText}
                                          >
                                            {translate("subtest_modified")}
                                          </Typography>
                                        }
                                      />
                                    ) : null}
                                  </Typography>
                                }
                              />
                              {test[item.id] == true ? (
                                <Button
                                  className={classes.editBtn}
                                  color="primary"
                                  onClick={() => this.onSubtestEdit(item)}
                                  //disabled={customerTargets && customerTargets.length == 10}
                                >
                                  <Icon> edit </Icon> Edit
                                </Button>
                              ) : null}

                              <Divider />
                            </div>
                          );
                        })
                      : null}
                  </FormGroup>
                )}
                {tabView === "tab_transmission" && (
                  <FormGroup>
                    {transTestData
                      ? transTestData.map((item, index) => {
                          return (
                            <div>
                              <FormControlLabel
                                className={classes.textFieldL}
                                control={
                                  <Checkbox
                                    name={item.id}
                                    checked={
                                      test[item.id] == true ? true : false
                                    }
                                    onChange={this.onSubtestChange}
                                    value={
                                      test[item.id] ? test[item.id] : false
                                    }
                                    color="primary"
                                  />
                                }
                                label={
                                  <Typography className={classes.lookup}>
                                    {translate(item.id)}
                                    {test.hasOwnProperty(
                                      item.id + "details"
                                    ) ? (
                                      <Chip
                                        className={classes.chip}
                                        size="small"
                                        label={
                                          <Typography
                                            className={classes.chipText}
                                          >
                                            {translate("subtest_modified")}
                                          </Typography>
                                        }
                                      />
                                    ) : null}
                                  </Typography>
                                }
                              />
                              {test[item.id] == true ? (
                                <Button
                                  className={classes.editBtn}
                                  color="primary"
                                  onClick={() => this.onSubtestEdit(item)}
                                  //disabled={customerTargets && customerTargets.length == 10}
                                >
                                  <Icon> edit </Icon> Edit
                                </Button>
                              ) : null}
                              <Divider />
                            </div>
                          );
                        })
                      : null}
                  </FormGroup>
                )}
                {tabView === "tab_wiremap" && (
                  <FormGroup>
                    {wireTestData
                      ? wireTestData
                          .filter(type => type.id != "wiremapcustomcables")
                          .map((item, index) => {
                            return (
                              <div>
                                <FormControlLabel
                                  className={classes.textFieldL}
                                  control={
                                    <Checkbox
                                      name={item.id}
                                      checked={
                                        test[item.id] == true ? true : false
                                      }
                                      onChange={this.onSubtestChange}
                                      value={
                                        test[item.id] ? test[item.id] : false
                                      }
                                      color="primary"
                                    />
                                  }
                                  label={
                                    <Typography className={classes.lookup}>
                                      {translate(item.id)}
                                      {test.hasOwnProperty(
                                        item.id + "details"
                                      ) ? (
                                        <Chip
                                          className={classes.chip}
                                          size="small"
                                          label={
                                            <Typography
                                              className={classes.chipText}
                                            >
                                              {translate("subtest_modified")}
                                            </Typography>
                                          }
                                        />
                                      ) : null}
                                    </Typography>
                                  }
                                />
                                {test[item.id] == true ? (
                                  <Button
                                    className={classes.editBtn}
                                    color="primary"
                                    onClick={() => this.onSubtestEdit(item)}
                                    //disabled={customerTargets && customerTargets.length == 10}
                                  >
                                    <Icon> edit </Icon> Edit
                                  </Button>
                                ) : null}
                                <Divider />
                              </div>
                            );
                          })
                      : null}
                  </FormGroup>
                )}
                {tabView === "tab_poe" && (
                  <div>
                    <FormGroup>
                      {poeTestData
                        ? poeTestData.map((item, index) => {
                            return (
                              <div>
                                <FormControlLabel
                                  className={classes.textFieldL}
                                  control={
                                    <Checkbox
                                      name={item.id}
                                      checked={
                                        test[item.id] == true ? true : false
                                      }
                                      onChange={this.onSubtestChange}
                                      value={
                                        test[item.id] ? test[item.id] : false
                                      }
                                      color="primary"
                                    />
                                  }
                                  label={
                                    <Typography className={classes.lookup}>
                                      {translate(item.id)}
                                      {test.hasOwnProperty(
                                        item.id + "details"
                                      ) ? (
                                        <Chip
                                          className={classes.chip}
                                          size="small"
                                          label={
                                            <Typography
                                              className={classes.chipText}
                                            >
                                              {translate("subtest_modified")}
                                            </Typography>
                                          }
                                        />
                                      ) : null}
                                    </Typography>
                                  }
                                />
                                {test[item.id] == true ? (
                                  <Button
                                    className={classes.editBtn}
                                    color="primary"
                                    onClick={() => this.onSubtestEdit(item)}
                                    //disabled={customerTargets && customerTargets.length == 10}
                                  >
                                    <Icon> edit </Icon> Edit
                                  </Button>
                                ) : null}
                                <Divider />
                              </div>
                            );
                          })
                        : null}
                    </FormGroup>
                  </div>
                )}
                {tabView === "tab_fiber" && (
                  <div>
                    <FormGroup>
                      {fiberTestData
                        ? fiberTestData.map((item, index) => {
                            return (
                              <div>
                                <FormControlLabel
                                  className={classes.textFieldL}
                                  control={
                                    <Checkbox
                                      name={item.id}
                                      checked={
                                        test[item.id] == true ? true : false
                                      }
                                      onChange={this.onSubtestChange}
                                      value={
                                        test[item.id] ? test[item.id] : false
                                      }
                                      color="primary"
                                    />
                                  }
                                  label={
                                    <Typography className={classes.lookup}>
                                      {translate(item.id)}
                                      {test.hasOwnProperty(
                                        item.id + "details"
                                      ) ? (
                                        <Chip
                                          className={classes.chip}
                                          size="small"
                                          label={
                                            <Typography
                                              className={classes.chipText}
                                            >
                                              {translate("subtest_modified")}
                                            </Typography>
                                          }
                                        />
                                      ) : null}
                                    </Typography>
                                  }
                                />
                                {test[item.id] == true ? (
                                  <Button
                                    className={classes.editBtn}
                                    color="primary"
                                    onClick={() => this.onSubtestEdit(item)}
                                    //disabled={customerTargets && customerTargets.length == 10}
                                  >
                                    <Icon> edit </Icon> Edit
                                  </Button>
                                ) : null}
                                <Divider />
                              </div>
                            );
                          })
                        : null}
                    </FormGroup>
                  </div>
                )}
              </form>
            </ModalContents>

            <ModalFooter>
              {isSubTestError == true ? (
                <Typography className={classes.sterror}>
                  {translate("add_cust_subtest_required")}
                </Typography>
              ) : null}
              <Button
                raised
                className={classes.button}
                onClick={() => this.tabBack()}
                disabled={!this.canTabBack().can ? true : false}
              >
                <Icon>navigate_before</Icon>
              </Button>

              <Button
                raised
                className={classes.button}
                onClick={() => this.tabNext()}
                disabled={!this.canTabNext().can ? true : false}
              >
                <Icon>navigate_next</Icon>
              </Button>

              {this.tabsComplete() ? (
                <Button
                  raised
                  color="accent"
                  className={classes.submit}
                  onClick={() => this.createTests()}
                  type="submit"
                  disabled={
                    testIDType === "import" && Object.keys(IDerrors).length != 0
                  }
                >
                  {translate("test_create")}
                </Button>
              ) : null}
            </ModalFooter>
          </Paper>
        </div>
      </Modal>
    );
  }

  componentWillReceiveProps(nextProps) {
    const { testNameList, IDerrors } = nextProps;
    let test = { ...this.state.test };
    if (this.props.testNameList !== testNameList) {
      test.names = testNameList;
      this.setState({
        test
      });
    }
    // if (this.props.IDerrors !== IDerrors) {
    //   var tempIDErrors = IDerrors == null ? {} : IDerrors;
    //   this.setState({
    //     IDerrors: tempIDErrors
    //   });
    // }
  }

  componentDidMount() {
    const { test } = this.state;
    const { userPreference } = this.props;
    const disabledToogleIdentifier = test.metadata
      .filter(identifier => identifier.level !== "1")
      .every(identifier => identifier.default === true);
    this.setState({
      disabledToogleIdentifier
    });
    var isUserPreferenceSaved = false;
    userPreference &&
      userPreference.metadata.map(x => {
        if (x.value != null) isUserPreferenceSaved = true;
      });
    if (isUserPreferenceSaved == true) {
      this.checkForAlreadySelectedSubtests(
        this.state.test,
        this.props.type == "copper" ? "true" : "false"
      );
    }
    this.checkForAlreadySelectedSubtestsSignaltek(
      this.state.test,
      this.props.type == "copper" ? "true" : "false"
    );
    if (!this.props.modalState) {
      const { standards } = this.props;
      let cablebrand = "";
      let cablemodelid = "";
      let nvp = 68;
      let cableshielding = "U/UTP";
      let cablemodels = [];
      let linkmodels = [];
      let cabletypes = [];
      const brand =
        standards && standards.cablebrands
          ? standards.cablebrands.find(x => x.name.toLowerCase() == "generic")
          : null;
      if (brand) {
        cablebrand = brand.id;
        if (brand.cablemodels) {
          cablemodels = brand.cablemodels;
          let cablemodel = cablemodels.find(
            x => x.name.toLowerCase() == "cat6a"
          );
          if (cablemodel) {
            cablemodelid = cablemodel.id;
            if (
              cablemodel.nvp &&
              (cablemodel.nvp >= 50 && cablemodel.nvp <= 100)
            ) {
              nvp = cablemodel.nvp;
            } else {
              nvp = 68;
            }

            if (cablemodel.screen) {
              cableshielding = "S/STP";
            } else {
              cableshielding = "U/UTP";
            }
          }
        }
      } else {
        nvp = 68;
        cableshielding = "U/UTP";
      }

      if (standards && standards.cablestandards) {
        const cStandard = standards.cablestandards.find(
          o => o.name.toUpperCase() === "ISO/IEC 11801-1:2017 A1/2"
        );
        if (cStandard) {
          linkmodels = cStandard.linkmodels;
          test.cablestandardname = cStandard.name;
          test.cablestandard = cStandard.id;
          const lModel = cStandard.linkmodels.find(
            o => o.name.toUpperCase() === "PERMANENT LINK"
          );
          if (lModel) {
            cabletypes = lModel.cabletypes;
            test.linkmodelname = lModel.name;
            test.linkmodel = lModel.id;
            const cType = lModel.cabletypes.find(
              o => o.name.toUpperCase() === "CLASS EA PL1 PL2 CP1"
            );
            if (cType) {
              test.cabletypename = cType.name;
              test.cabletype = cType.id;
            }
          }
        }
      }

      this.setState({
        test: {
          ...test,
          cablebrand,
          cablemodelid,
          nvp,
          cableshielding
        },
        cablemodels,
        linkmodels,
        cabletypes
      });
    }
  }

  componentWillMount() {
    if (this.props.modalState) {
      const test = this.props.modalState;
      const standards = this.props.standards;
      let cablemodels = [];
      let linkmodels = [];
      let cabletypes = [];
      let isNonGenericCableBrand = false;
      if (test.cablebrand) {
        const brand = standards
          ? standards.cablebrands.find(x => x.id == test.cablebrand)
          : null;
        if (brand) {
          if (brand.name.toLowerCase() == "generic") {
            isNonGenericCableBrand = false;
          } else {
            isNonGenericCableBrand = true;
          }
          cablemodels = brand.cablemodels;
        }
      }
      if (test.cablestandard) {
        const standard =
          standards && standards.cablestandards
            ? standards.cablestandards.find(x => x.id == test.cablestandard)
            : null;
        linkmodels =
          standard && standard.linkmodels ? standard.linkmodels : null;
      }
      if (test.linkmodel) {
        const linkmodel = linkmodels
          ? linkmodels.find(x => x.id == test.linkmodel)
          : null;
        cabletypes =
          linkmodel && linkmodel.cabletypes ? linkmodel.cabletypes : null;
      }

      this.setState({
        test,
        isNonGenericCableBrand,
        cablemodels,
        linkmodels,
        cabletypes,
        tabView: this.state.tabs[0]
      });
    }
  }
}

const mapStateToProps = state => ({
  selectedTestResult: state.subtestReducer.selectedTestResult,
  customerTargets4: state.customerReducer.customerTargets4,
  customerTargets6: state.customerReducer.customerTargets6,
  selectedTrResult: state.subtestReducer.selectedTrResult,
  upTime: state.subtestReducer.upTime,
  netScan: state.subtestReducer.netScan,
  customerPoELoad: state.customerReducer.customerPoELoad,
  wireMap: state.subtestReducer.wireMap,
  cableList: state.subtestReducer.cableList,
  maxThroughPut: state.subtestReducer.maxThroughPut,
  fiberLengthLoss: state.subtestReducer.fiberLengthLoss,
  subtestSettings: state.subtestReducer.subtestSettings,
  ...state
});

const mapDispatchToProps = (dispatch, props) => ({
  getPingDetails: cid => {
    dispatch(getSubTestPing(cid));
  },
  getCustTargets4: id => {
    dispatch(getCustomerTargets4(id));
  },
  getCustTargets6: id => {
    dispatch(getCustomerTargets6(id));
  },
  getTrDetails: cid => {
    dispatch(getSubTestTr(cid));
  },
  updateTrDetails: (id, trDetails) => {
    dispatch(updateSubTestTr(id, trDetails));
  },
  getUpTime: () => {
    dispatch(getUpTime());
  },
  getNetScan: () => {
    dispatch(getNetScan());
  },
  getCustPoELoad: () => {
    dispatch(getCustomerPoELoad());
  },
  getWireMap: () => {
    dispatch(getWireMap());
  },
  getFiberLengthLoss: () => {
    dispatch(getFiberLengthLoss());
  },
  getCableList: id => {
    dispatch(getCableList(id));
  },
  getMaxThroughPut: () => {
    dispatch(getMaxThroughPut());
  },
  getSubtestSettings: subTestType => {
    dispatch(getSubtestSettings(subTestType));
  }
});

export default withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(NewSignalTekTest)
);



// WEBPACK FOOTER //
// ./src/components/job/newsignaltek/index.js